import { render, staticRenderFns } from "./QA.vue?vue&type=template&id=d84866b4"
import script from "./QA.vue?vue&type=script&lang=js"
export * from "./QA.vue?vue&type=script&lang=js"
import style0 from "./QA.vue?vue&type=style&index=0&id=d84866b4&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports